import { render, staticRenderFns } from "./AddOccupant.vue?vue&type=template&id=c74b9b6c"
import script from "./AddOccupant.vue?vue&type=script&lang=js"
export * from "./AddOccupant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports